import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'profit-pro',
    templateUrl: 'profit-pro.component.html',
    styleUrls: ['./profit-pro.component.scss']
})

export class ProfitPro implements OnInit{

    private readonly productAreaOrigin = 'Home';
    private readonly product = 'Profit Pro';
    private readonly scenario = 'Trader';
    private readonly status = 'Aberta';
    private readonly timeResponsavel = 'Sky';
    private readonly notApplicable = 'Não se aplica';

    constructor(
        private store: Store<any>,
        private router: Router
    ) {}

    public ngOnInit() {
        this.sendTracking("Page Loaded", {
            'Product Area Origin': this.productAreaOrigin,
            'Status': this.status,
            'Scenario': this.scenario,
            'Step': this.product,
            'Time Responsável': this.timeResponsavel,
            'Current URL': '/lp-profit-pro',
        });
    }

    public navigateTo(path: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': this.productAreaOrigin,
            'Element': 'Botão Transferir',
            'Group': this.notApplicable,
            'Step': this.product,
            'Scenario': this.scenario,
            'Status': this.status,
            'Label': this.notApplicable,
            'Text': this.notApplicable,
            'Time Responsável': this.timeResponsavel,
        });

        this.router.navigate([path]);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}